import React, { Component } from 'react';
import { configureScope, captureException } from '@sentry/browser';
import withCountryCode from '../../components/RoutesHoc/RoutesHoc';
import PageNotFound from '../../pages/PageNotFound';

class SentryBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    const dsn = process.env.SENTRY_DSN_CONSUMER || null;
    if (dsn) {
      configureScope(scope => {
        Object.keys(errorInfo).forEach(key => {
          scope.setExtra(key, errorInfo[key]);
        });
      });
      captureException(error);
    }
  }

  render() {
    const { children } = this.props;
    const { error } = this.state;
    if (error) {
      return <PageNotFound />;
    }
    return children;
  }
}

export default withCountryCode(SentryBoundary);
